import { AccountTreeOutlined } from '@mui/icons-material';
import { FC } from 'react';

interface IMainMenuItem {
  icon: FC;
  path?: string;
  label: string;
  forRoles?: string[];
  subItems: Omit<IMainMenuItem, 'icon' | 'subItems'>[];
}

export const mainMenuItems: IMainMenuItem[] = [
  {
    icon: AccountTreeOutlined,
    label: 'Workflows',
    forRoles: ['ALL'],
    subItems: [
      {
        label: 'NCR',
        path: '/workflows/NCR/overview',
        forRoles: ['ALL'],
      },
    ],
  },
  {
    icon: AccountTreeOutlined,
    label: 'Snags',
    forRoles: ['ALL'],
    subItems: [
      {
        label: 'Walkdowns',
        path: '/snags/walkdowns',
        forRoles: ['ALL'],
      },
    ],
  },
  {
    icon: AccountTreeOutlined,
    label: 'Admin',
    forRoles: ['ADMIN'],
    subItems: [
      {
        label: 'Master Data',
        path: '/workflows/NCR/admin/master-data',
        forRoles: ['ADMIN'],
      },
      {
        label: 'Permissions',
        path: '/workflows/NCR/permissions',
        forRoles: ['ADMIN'],
      },
    ],
  },
];
